import React from 'react';
import { Helmet } from 'react-helmet-async';
interface SEOHeadProps {
  title?: string;
  description?: string;
}
export function SEOHead({
  title,
  description
}: SEOHeadProps) {
  const fullTitle = title ? `${title} | Mick van Latum` : 'Mick van Latum - UX Designer & AI Developer';
  const defaultDescription = 'Translating complex questions into elegant solutions through UX Design, AI Integration, and Development.';
  return <Helmet data-id="element-994">
      <title data-id="element-995">{fullTitle}</title>
      <meta name="description" content={description || defaultDescription} data-id="element-996" />
      <meta property="og:title" content={fullTitle} data-id="element-997" />
      <meta property="og:description" content={description || defaultDescription} data-id="element-998" />
      <meta name="twitter:title" content={fullTitle} data-id="element-999" />
      <meta name="twitter:description" content={description || defaultDescription} data-id="element-1000" />
    </Helmet>;
}